// src/utils/analytics.js
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp, setDoc, doc } from 'firebase/firestore';

const BURST_LIMIT = 20;
const BURST_WINDOW_MS = 10000;
let localEvents = [];

/**
 * Tracks a custom event to Firestore telemetry collection.
 * @param {string} eventName - Name of the event (e.g., 'play_start')
 * @param {Object} properties - Metadata associated with the event
 * @param {string} userId - Optional user ID
 */
export const trackEvent = async (eventName, properties = {}, userId = null) => {
  try {
    // 1. Check for local ban flag
    if (localStorage.getItem('listen2_banned') === 'true') return;

    const deviceId = localStorage.getItem('listen2_device_id') || 'unknown';
    const now = Date.now();

    // 2. Client-Side Burst Protection (Auto-Ban)
    localEvents.push(now);
    localEvents = localEvents.filter(t => (now - t) < BURST_WINDOW_MS);

    if (localEvents.length > BURST_LIMIT) {
      console.warn("Security Alert: Behavioral burst detected. Triggering Auto-Ban.");
      localStorage.setItem('listen2_banned', 'true');
      
      // Attempt to self-report and ban
      const targetId = userId || deviceId;
      await setDoc(doc(db, 'banned_users', targetId), {
        bannedAt: serverTimestamp(),
        reason: "Automated Edge Protection: Behavioral burst detected (>20 events/10s)",
        isAutoBanned: true
      });
      return;
    }

    const telemetryRef = collection(db, 'telemetry');
    await addDoc(telemetryRef, {
      event: eventName,
      ...properties,
      userId: userId,
      deviceId,
      timestamp: serverTimestamp(),
      userAgent: navigator.userAgent,
      path: window.location.pathname,
    });
    // console.log(`[Analytics] Tracked: ${eventName}`, properties);
  } catch (error) {
    console.error(`[Analytics] Error tracking ${eventName}:`, error);
  }
};

/**
 * Common event helpers
 */
export const AnalyticsEvents = {
  USER_SIGNUP: 'user_signup',
  USER_LOGIN: 'user_login',
  PLAY_START: 'play_start',
  PLAY_PAUSE: 'play_pause',
  PLAY_COMPLETE: 'play_complete',
  EPISODE_SKIP: 'episode_skip',
  SPEED_CHANGE: 'speed_change',
  PAGE_VIEW: 'page_view',
  PODCAST_FOLLOW: 'podcast_follow',
  SEARCH_PERFORMED: 'search_performed',
};
